import { render, staticRenderFns } from "./VDropdownItem.vue?vue&type=template&id=b9cf8cda&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9cf8cda')) {
      api.createRecord('b9cf8cda', component.options)
    } else {
      api.reload('b9cf8cda', component.options)
    }
    module.hot.accept("./VDropdownItem.vue?vue&type=template&id=b9cf8cda&", function () {
      api.rerender('b9cf8cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dropdown/VDropdownItem.vue"
export default component.exports